import BackgroundTable from './BackgroundTable/BackgroundTable';
import Page from '../Page';

function PageTable({children}) {
    return (
        <Page>
            <BackgroundTable>
                {children}
            </BackgroundTable>
        </Page>
    )
}

export default PageTable;